/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Heading } from 'sarsaparilla';
import SearchFilterAgencies from '../../SearchFilterAgencies';
import SearchFilterActivities from '../../SearchFilterActivities';
import { getCount } from '../../../utils/filters';
import { AggregationProps, UiFiltersProps } from '../../../types/filters';

export type AdditionalPreferencesProps = {
    aggregations: AggregationProps;
    uiFilters: UiFiltersProps;
    onFilterToggle: (v: string, k: any) => void;
    onApplyFilters: () => void;
    hideActivities?: boolean;
};

function AdditionalPreferences({
    aggregations,
    uiFilters,
    onFilterToggle,
    onApplyFilters,
    hideActivities = false,
}: AdditionalPreferencesProps) {
    const countKeys = hideActivities ? ['agencies'] : ['agencies', 'activities'];
    const additionalPreferencesCount = getCount(countKeys, uiFilters);
    return (
        <div className="mb-4">
            <div className="search-filters-section-header rounded-layout mb-1 mt-4">
                <Heading headingLevel={2} appearance="h5">
                    Additional Preferences.
                </Heading>
                <span>
                    {additionalPreferencesCount}{' '}
                    {additionalPreferencesCount > 1 || additionalPreferencesCount === 0
                        ? 'Filters'
                        : 'Filter'}{' '}
                    Selected
                </span>
            </div>
            <div className="search-filters-filter-container pt-0">
                {process.env?.SEARCH?.showFederalAgencies && (
                    <SearchFilterAgencies
                        uiFilters={uiFilters}
                        aggregations={aggregations}
                        onFilterToggle={onFilterToggle}
                        onApplyFilters={onApplyFilters}
                        expandable
                    />
                )}

                {!hideActivities && (
                    <SearchFilterActivities
                        uiFilters={uiFilters}
                        aggregations={aggregations}
                        onFilterToggle={onFilterToggle}
                        onApplyFilters={onApplyFilters}
                        expandable
                    />
                )}
            </div>
        </div>
    );
}

export default AdditionalPreferences;
